import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { KeywordCompareComponent } from "./KeywordCompareComponent";
import { PageHeader } from "../../../../components/PageHeader";
import { findAllClusters } from "../../../../api/specialization/KeywordSpecializationAPI";

export function KeywordComparePage() {
  const { t } = useTranslation(["common", "keyword"]);

  const [clusters, setClusters] = useState([]);
  const [clustersToCompare, setClustersToCompare] = useState([
    { name: "A", data: {} },
    { name: "B", data: {} },
  ]);
  const [countClustersToCompare, setCountClustersToCompare] = useState(2);
  useEffect(() => {
    findAllClusters()
      .then((res) => {
        setClusters(res);
      })
      .catch(() => {});
  }, []);
  console.log(clusters);

  var clustersDisplays = clustersToCompare.map(
    (cluster: any, index: number) => {
      console.log(clusters);
      return (
        <KeywordCompareComponent
          clusters={clusters}
          variant={index == 0 ? "main" : "against"}
          width={
            12 / (clustersToCompare.length > 0 ? clustersToCompare.length : 1)
          }
          chosenCluster={clusters.length > 0 ? clusters[0] : null}
          changeClusterAction={(cluster: any) => {console.log("CHANGED" + cluster)}}
        />
      );
    }
  );

  return (
    <Grid container>
      <PageHeader text={t("keyword:cluster_list")}></PageHeader>
      <Grid item xs={0.75} />
      <Grid container xs={10.5}>
        {clustersDisplays}
      </Grid>
      <Grid item xs={0.75} />
    </Grid>
  );
}
